import { useEffect, useState } from "react";
import api from "@/utils/api";
import { toast } from "sonner";

// Admin switch: combined monthly invoices for business customers (today) vs one invoice per shipment for everyone.
export default function InvoicePolicySwitch({ isAdmin }) {
  const [value, setValue] = useState(null);
  useEffect(() => { api.get("/v2/billing/policy").then((r) => setValue(r.data.value)).catch(() => {}); }, []);
  if (!value) return null;
  const change = async (v) => {
    if (v === value) return;
    const msg = v === "per_shipment"
      ? "Switch to ONE INVOICE PER SHIPMENT for every customer?\n\nBusiness customers will be invoiced after each bill is finalised; month-end combined drafts stop. Existing invoices do not change."
      : "Switch back to COMBINED MONTHLY invoices for business customers?";
    if (!window.confirm(msg)) return;
    const reason = window.prompt("Reason (e.g. CA advice, date):") || "";
    try { const r = await api.put("/v2/billing/policy", { value: v, reason }); setValue(r.data.value); toast.success("Invoicing policy updated"); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not change the policy"); }
  };
  const label = value === "per_shipment" ? "One invoice per shipment" : "Business: combined monthly";
  if (!isAdmin) return <span className="text-xs text-slate-500 self-center" data-testid="invoice-policy">Invoicing: {label}</span>;
  return (
    <label className="text-xs text-slate-600 flex items-center gap-1.5" data-testid="invoice-policy">
      Invoicing
      <select value={value} onChange={(e) => change(e.target.value)} className="h-9 rounded-md border border-slate-300 bg-white px-2 text-sm">
        <option value="monthly_combined">Business: combined monthly</option>
        <option value="per_shipment">One invoice per shipment</option>
      </select>
    </label>
  );
}
